import { render, staticRenderFns } from "./IntersectionObserver.vue?vue&type=template&id=7530a6a1&scoped=true"
import script from "./IntersectionObserver.vue?vue&type=script&lang=js"
export * from "./IntersectionObserver.vue?vue&type=script&lang=js"
import style0 from "./IntersectionObserver.vue?vue&type=style&index=0&id=7530a6a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7530a6a1",
  null
  
)

export default component.exports